import { Input } from "@/components/ui/input";

const ROWS = [
  ["start_rule", "Start date", "When the job card appears and work can start"],
  ["internal_rule", "Internal deadline", "Our target date"],
  ["deadline_rule", "Deadline", "Statutory / filing deadline"],
];
const num = "rounded-lg bg-white border-[#103080]/20 h-9 text-sm w-20";

export default function TemplateDates({ value, onChange }) {
  const set = (key, part, raw) => {
    const cur = value[key] || { months: 0, days: 0 };
    const next = { ...cur, [part]: raw === "" ? 0 : Math.max(0, Number(raw)) };
    onChange({ ...value, [key]: next });
  };
  return (
    <section className="rounded-xl border border-[#103080]/10 bg-white p-4 space-y-3" data-testid="template-dates">
      <div>
        <p className="font-semibold text-[#103080] text-sm">Dates</p>
        <p className="text-xs text-[#0F172A]/55">Months and days after the period end / year end. They're worked out for each client's job card and override Settings → Deadlines. Leave blank to use the service default.</p>
      </div>
      {ROWS.map(([key, label, hint]) => {
        const r = value[key];
        return (
          <div key={key} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`template-${key}`}>
            <div className="w-44"><p className="font-medium text-[#103080]">{label}</p><p className="text-[11px] text-[#0F172A]/45">{hint}</p></div>
            <Input type="number" min={0} max={36} value={r ? r.months : ""} placeholder="–" onChange={(e) => set(key, "months", e.target.value)} className={num} aria-label={`${label} months`} data-testid={`template-${key}-months`} />
            <span className="text-xs text-[#0F172A]/55">months</span>
            <Input type="number" min={0} max={365} value={r ? r.days : ""} placeholder="–" onChange={(e) => set(key, "days", e.target.value)} className={num} aria-label={`${label} days`} data-testid={`template-${key}-days`} />
            <span className="text-xs text-[#0F172A]/55">days after period end</span>
            {r && <button type="button" onClick={() => onChange({ ...value, [key]: null })} data-testid={`template-${key}-clear`} className="text-xs font-semibold text-[#0090D0] hover:text-[#103080] ml-1">Clear</button>}
          </div>
        );
      })}
    </section>
  );
}
